import React, {useEffect} from 'react'
import {connect} from 'react-redux'

import {changeVisibleState} from '../../../Redux/actions'
import {resetRegistrationPart, saveRegistrationPart} from '../../../Redux/actions/registrationAction'
import {addRegistrationPart, changeRegistrationState, deleteRegistrationPart} from '../../../Redux/actions/registrationAction'
import {addDiscountMargin, changePriceState} from '../../../Redux/actions/priceAction'
import {EditorID} from "../../../data/data";

import BottomButtons from '../../general/BottomButtons'
import LabelInput from '../../general/LabelInput'
import TablePartPrices from './TablePartPrices'


const RegistrationPartEditor = (props) => {

    const disabled = Boolean(props.registration.edit)

    useEffect(() => {
        if (!props.registration.edit_part) {
            props.changeRegistrationState({
                part_margin: props.discount_margin.map(margin => ({
                    cost: 0,
                    discount_margin_id: margin.id,
                    part_id: props.registration.part.id,
                }))
            })
        }
    }, [])

    const handleClose = () => {
        props.changeVisibleState({
            isCentralModalOpen: false,
            modalCentralType: '',
            inputRegistrationCountChecked: true
        })
        props.resetRegistrationPart()
    }

    const clickHandle = (event) => {
        const ids = event.composedPath().map(el => el.id);
        if (
            !ids.includes(EditorID.REGISTRATION_PART)
            && !ids.includes(EditorID.ADD_REGISTRATION_PART)

        ) {
            handleClose();
        }
    }

    useEffect(() => {
        window.addEventListener('click', clickHandle)
        return () => {
            window.removeEventListener('click', clickHandle)
        }
    })

    const handleCreate = () => {
        if (props.registration.count) {
            props.addRegistrationPart()
            handleClose()
        } else {
            props.changeVisibleState({inputRegistrationCountChecked: false})
        }

    }

    const handleSave = (idx) => {
        if (props.registration.count) {
            props.saveRegistrationPart(idx)
            handleClose()
        } else {
            props.changeVisibleState({inputRegistrationCountChecked: false})
        }
    }

    const handleDelete = (idx) => {
        props.deleteRegistrationPart(idx)
        handleClose()
    }

    return (
        <div className='modal__box_editor' id={EditorID.REGISTRATION_PART}>
            <div className='modal__block-forms'>
                <h4>{props.registration.part.title}</h4>

                <div className='modal__block-forms_row'>
                    <div className='modal__block-forms  w220'>
                        <LabelInput
                            title='Количество'
                            onChange={event => props.changeRegistrationState({count: parseInt(event.target.value.replace(/[^0-9]/g, '')) || 0})}
                            value={props.registration.count}
                            checkedFlag='inputRegistrationCountChecked'
                            redStar={true}
                            disabled={disabled}
                        />
                        <LabelInput
                            title='Закупочная цена'
                            onChange={event => props.changeRegistrationState({buy_cost: event.target.value.replace(/[^0-9.,]/g, '')})}
                            value={props.registration.buy_cost}
                            unit='Руб'
                            disabled={!props.permissions.includes('see_buy_cost')}
                            invisible={!props.permissions.includes('edit_buy_cost')}
                        />
                        {props.permissions.includes('edit_buy_cost') ? null :
                            <LabelInput
                                title='Место хранения'
                                onChange={event => props.changeRegistrationState({cell: event.target.value})}
                                value={props.registration.cell}
                                disabled={!Object.values(props.registration.warehouse).length}
                            />
                        }
                    </div>
                    <div className='modal__block-forms  w220'>
                        <LabelInput
                            title='Продавец'
                            onChange={event => props.changeRegistrationState({seller: event.target.value})}
                            value={props.registration.seller}
                        />
                        <LabelInput
                            title='Ссылка на товар'
                            onChange={event => props.changeRegistrationState({where_to_buy: event.target.value})}
                            value={props.registration.where_to_buy}
                        />
                    </div>
                </div>
                {props.permissions.includes('edit_buy_cost') ?
                    <LabelInput
                        title='Место хранения'
                        onChange={event => props.changeRegistrationState({cell: event.target.value})}
                        value={props.registration.cell}
                        disabled={!Object.values(props.registration.warehouse).length}
                    />
                    : null
                }

                <TablePartPrices/>

                <BottomButtons
                    edit={props.registration.edit_part}
                    create={handleCreate}
                    save={() => handleSave(props.registration.edit_part)}
                    delete={disabled ? null : () => handleDelete(props.registration.edit_part - 1)}
                    close={handleClose}
                />
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    discount_margin: state.price.discount_margin,
    registration: state.registration,
    view: state.view,
    permissions: state.data.user.role.permissions

})

const mapDispatchToProps = {
    changeVisibleState,
    resetRegistrationPart,
    changeRegistrationState,
    changePriceState,
    addDiscountMargin,
    addRegistrationPart,
    saveRegistrationPart,
    deleteRegistrationPart
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPartEditor)